// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkout-hot-box .checkout-hot-radio[data-v-7828ea21] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.hot-title[data-v-7828ea21] {\n  color: #333;\n  font-size: 14px;\n  font-family: PingFang SC-Regular, PingFang SC;\n  font-weight: 400;\n}", ""]);
// Exports
module.exports = exports;
